module.exports = __webpack_public_path__ + "static/media/Steppr loyalty and gifting - Trend Tonic.6f5020d8.webp";